module.exports = __webpack_public_path__ + "img/MES1_VideoThumbnail.e85805a9.png";